import Vue from 'vue'

export const MODULO_CONTABILIDADE = 'contabilidade'

/**
 * Módulo em que a navegação está, resolvido pelo `formataUrlBase` a cada rota.
 */
export const pegaModuloAtual = () => {
    return (Vue.prototype.$url && Vue.prototype.$url.module) || ''
}

/**
 * Diz se a tela está sendo servida dentro do portal da contabilidade
 * (`/contabilidade/*`).
 *
 * O shell (topo, menu do usuário, breadcrumb) é o MESMO do ERP: o portal só reusa os
 * componentes de `shared/`. Por isso todo ajuste de navegação feito para o portal tem
 * de ser condicional a este contexto — um ajuste global mudaria o ERP de todos os
 * clientes junto. GCK-20890.
 */
export const contextoContabil = () => {
    return pegaModuloAtual() === MODULO_CONTABILIDADE
}
